/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {error, info} from '@ion/core/src/logger/logger';
import {
  CTCEntity
} from '@ion/core/src/types/entities';
import {createOptions, Options} from '@ion/dls/src/components/menus/Dropdown';

//Provides the onchange function for automcomplete onchange
export const onDropDownChange = (onChange, value: Options, params) => {
  const val = value?.value;
  params?.setSelected(val);
  const returnVal = value ? getSelectedValue(params.listObj, val) : null;
  return onChange(returnVal, params?.keyObj);
};

//Provides the boolean value when we select the oprions from the automcomplete
export const getOptionSelected = (option, value) => {
  return option.value === value.value;
};

//Provides the label for autocomplete component
export const getOptionLabel = (option: any) => {
  return option?.label ?? option;
};

/**
 * Provides a utility which filters a list of options for the
 * currently selected id.
 */
export const getSelectedValue = (list: any, selected: string): CTCEntity => {
  return list.find(({id}) => id === selected);
};

/**
 * Generates the option dropdown labels and values based on
 * the provided options.
 */
export const getOptions = (options: CTCEntity[]): Options[] => {
  if (options?.length > 0) {
    return createOptions({
      items     : options,
      valProp   : 'id',
      labelProp : 'name'
    });
  }
  return [];
};

/**
 * Searches for and returns a complete list of entities that may span multiple pages.
 */
export const getAllEntities = async(
  entity: string,
  searchFunction: Function,
  searchParamsBase: {[key: string]: any}
): Promise<any[]> => {
  try {
    let currentPage = 1;
    let totalPages = 1;
    let totalResult = [];
    while (currentPage <= totalPages) {
      const searchParams = {
        ...searchParamsBase,
        pageId   : currentPage,
        pageSize : 100
      };
      const currentResult = await searchFunction(searchParams);
      totalResult = [...totalResult, ...currentResult[entity]];
      totalPages = Math.ceil(currentResult.totalCount / 100);
      currentPage += 1;
    };
    return totalResult;
  } catch (err) {
    info(`getAllEntities: Error occurred retrieving ${entity}`);
    error(err);
  }
  return [];
};
